import { ancillaryBundle } from '@eti/products';
import { connect } from 'react-redux';
import { formValueSelector, change as changeFormValue } from 'redux-form';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useProperty } from '@eti/providers';
import PropTypes from 'prop-types';
import { getTripNotificationChanges } from '../../../utils/notification';
import { useSkyscannerLandingTracking } from '../../../common/tracking/skyscannerTracking';
import { YOUR_SELECTED_TRIP } from '../../../constants/formNamesConstants';
import Loading from '../../../common/loading/components/Loading';
import NoSelectedTripErrorDialog from '../../../common/error-modals/NoSelectedTripErrorDialog';
import YourSelectedTripPage from '../components/YourSelectedTripPage';
import { useSelectedTrip } from './hooks/useSelectedTrip';
import useSnowPlowTracking from './hooks/useSnowPlowTracking';

const YourSelectedTripPageContainer = ({
  selectedBundleId,
  selectedBundlePrice,
  setSelectedBundleOption,
}) => {
  const history = useHistory();
  const { p } = useProperty();

  const {
    selectedTripData,
    isSelectTripLoading,
    isRefetching,
    noSelectedTripError,
    handleRefetch,
    selectTrip,
    prevBundleSelection,
    selectedExtraProducts,
  } = useSelectedTrip();

  useSkyscannerLandingTracking(selectedTripData);

  const { setSelectedTripDataForSnowPlow } = useSnowPlowTracking({
    category: 'Your Selected Trip',
    action: 'Seen',
    label: 'Page',
  });
  useEffect(() => {
    setSelectedTripDataForSnowPlow(selectedTripData);
  }, [selectedTripData, setSelectedTripDataForSnowPlow]);

  useEffect(() => {
    if (prevBundleSelection) {
      setSelectedBundleOption(prevBundleSelection);
    }
  }, [setSelectedBundleOption, prevBundleSelection]);

  const [isTripSelected, setIsTripSelected] = useState(false);

  const selectionKey = selectedTripData?.selectionKey || window.spa_variables.selectionKey;
  const shouldHideSelectedTrip =
    !history?.location?.state?.shouldShowSelectedTrip ||
    p('YourSelectedTrip.Page.HideSelectedTrip.Enabled');

  if (noSelectedTripError) {
    return <NoSelectedTripErrorDialog />;
  }
  if ((isSelectTripLoading || !selectedTripData) && !isRefetching && !isTripSelected) {
    return <Loading />;
  }

  const handleSelectTrip = async (variables) => {
    setIsTripSelected(true);
    await selectTrip({ ...variables });
  };
  const BrandedFaresVersion = p('YourSelectedTrip.Page.BrandedFares.Version');
  const { brandedFares } = selectedTripData ?? {};
  const shouldDisplayBrandedFares = p('BrandedFares.Enabled') && brandedFares?.length > 0;

  return (
    <YourSelectedTripPage
      {...(selectedTripData ?? {})}
      isSelectTripLoading={isSelectTripLoading}
      isSelectedTripRefetching={isRefetching}
      refetch={handleRefetch}
      selectTrip={
        (BrandedFaresVersion === 2 || BrandedFaresVersion === 3) && shouldDisplayBrandedFares
          ? handleSelectTrip
          : selectTrip
      }
      selectedBundleId={selectedBundleId}
      selectedBundlePrice={selectedBundlePrice}
      selectedExtraProducts={selectedExtraProducts}
      selectionKey={selectionKey}
      setSelectedBundleOption={setSelectedBundleOption}
      shouldHideSelectedTrip={shouldHideSelectedTrip}
      tripChange={getTripNotificationChanges(selectedTripData?.changes, selectedTripData?.bounds)}
    />
  );
};

YourSelectedTripPageContainer.propTypes = {
  selectedBundleId: PropTypes.string,
  selectedBundlePrice: PropTypes.number,
  setSelectedBundleOption: PropTypes.func,
  variables: PropTypes.shape({
    bundleProductSelection: PropTypes.object,
    extraProductSelection: PropTypes.arrayOf(PropTypes.string),
    searchPath: PropTypes.string,
    selectionKey: PropTypes.string,
  }),
};

const mapStateToProps = (state) => {
  const { value } = formValueSelector(YOUR_SELECTED_TRIP)(state, ancillaryBundle.name) || {};
  return {
    selectedBundleId: value?.id,
    selectedBundlePrice: value?.price,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedBundleOption: (selectedOption) =>
      dispatch(
        changeFormValue(YOUR_SELECTED_TRIP, `${ancillaryBundle.name}.value`, {
          value: selectedOption.type,
          price: selectedOption.priceRaw,
          id: selectedOption.id,
        }),
      ),
  };
};

const connectToStore = connect(mapStateToProps, mapDispatchToProps);

export default connectToStore(YourSelectedTripPageContainer);
